"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("../../components/SvgIcon"));
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], Object.assign({
    viewBox: '0 0 300 300'
  }, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "cut-off-youtube"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: 'scale(0.8) translate(-12 -10)'
  }, /*#__PURE__*/_react["default"].createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    d: "M199.91667116 105.6302382s-84.29180001.00007866-105.44791902 5.49739608c-11.32771618 3.16506938-20.655211 12.49266687-23.82031238 23.98698305-5.49727075 21.15613367-5.49739608 64.9687477-5.49739608 64.9687477s.00012533 43.97893404 5.49739608 64.80208104c3.16510139 11.49416018 12.3260082 20.65517366 23.82031238 23.82032038 21.32270701 5.6638401 105.44791902 5.66405342 105.44791902 5.66405342s84.45890802-.00006666 105.61458836-5.49738675c11.49438685-3.16508005 20.655107-12.15954686 23.65364037-23.82032038 5.66390676-20.98976034 5.66406676-64.80208104 5.66406676-64.80208104s.16645334-43.9792807-5.66406676-65.13541437c-2.99853338-11.49431618-12.15925352-20.65511233-23.65364037-23.65364971-21.15568034-5.83046276-105.61458836-5.83072943-105.61458836-5.83072943zm-26.8203071 53.97395285 70.13281446 40.47917398-70.13281445 40.31250732v-80.7916813z"
  })))), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: 'currentColor',
    cx: "150",
    cy: "150",
    r: "150",
    mask: "url(#cut-off-youtube)"
  }));
});